import { Injectable } from '@angular/core';
import { AppMetadataHandler } from '../../configs/app-metadata.handler'
import { CommonUtilty } from './commonUtility';
import { dateUtil } from './dateUtil';
import { ClaimPaymentDO } from 'app/BaseFramework/shared/models';

@Injectable()
export class clientUtil {
    constructor(
        public appMetadataHandler: AppMetadataHandler,
        public commonUtility: CommonUtilty,
        public dateUtil: dateUtil
    ) { }

    // formatContactNumber(std: string, isd: string, contactNum: string): string {
    //     let formattedStd = this.commonUtility.NVL(std);
    //     let formattedIsd = this.commonUtility.NVL(isd);
    //     let formattedContactNum = this.commonUtility.NVL(contactNum);

    //     // Ensure "NA" or empty values are not shown
    //     formattedStd = formattedStd === 'NA' ? '' : formattedStd;
    //     formattedIsd = formattedIsd === 'NA' ? '' : formattedIsd;

    //     return `${formattedStd ? `(${formattedStd}) ` : ''}` +
    //         `${formattedIsd ? `(${formattedIsd}) ` : ''}` +
    //         `${formattedContactNum}`;
    // }

    
    creatClientListObject(clientDO){

    }

    checkSameClient(client1, client2) {
        return client1.clientRefGuid == client2.clientRefGuid && client1.policyNum == client2.policyNum
    }

    mapClientToSelectedRole(clientMap, client , selectedRole, overrideExistingClient?){
        if(typeof clientMap == 'undefined')clientMap={}
        if(typeof clientMap[selectedRole] == 'undefined')clientMap[selectedRole]={}
        if(typeof clientMap[selectedRole][client.policyNum] == 'undefined')clientMap[selectedRole][client.policyNum]=[]
        if(overrideExistingClient){
            clientMap[selectedRole]={}
            clientMap[selectedRole][client.policyNum]=[client]
        }
        clientMap[selectedRole][client.policyNum] = this.commonUtility.uniquePushInArray(clientMap[selectedRole][client.policyNum], client,'clientRefGuid')
        return clientMap
    }

    createPaymentDO(client) {
        let paymentDo = new ClaimPaymentDO();
        paymentDo["clientRefGuid"] = client.clientRefGuid;
        paymentDo["clientDO"] = client.clientDO;
        paymentDo['policyNum'] = client.policyNum
        return paymentDo
    }

    createClientMap(clientList){
        let clients = this.commonUtility.convertMapWithMultipleValuesToArray_New(clientList)
        return this.commonUtility.convertArrayToMap(clients, 'clientRefGuid')
    }
    updateClientMap(clientMap_HM, clientDO) {
        if (clientDO && clientDO.guid) {
            if (clientMap_HM) {
                if (typeof clientMap_HM[clientDO.guid] == 'undefined')
                    clientMap_HM[clientDO.guid] = {}
                clientMap_HM[clientDO.guid]['clientDO'] = clientDO
            }
        }
        return clientMap_HM
    }
    setIsPayeeFlag(client,clientRoleList){
        if(clientRoleList && clientRoleList.length>0){
            clientRoleList.forEach(clientRole => {
                if(clientRole.clientRefGuid == client.clientRefGuid){
                    clientRole.isPayee = true
                }
            });
        }
    }
    /**
 * Adds a client entry to the provided HashMap if it does not already exist.
 * 
 * @param clientDO_HM - The HashMap containing existing clients.
 *                      Structure: { clientRefGuid1: clientObj1, clientRefGuid2: clientObj2, ... }
 * @param clientObject - The new client entry to add.
 *                       Structure: { clientRefGuid: clientObj }
 * 
 * Functionality:
 * - Checks if the clientRefGuid key from clientObject already exists in clientDO_HM.
 * - If the clientRefGuid is NOT present, adds the clientObject into clientDO_HM.
 * - If already present, skips addition and logs that client is already existing.
 */
    addClientTo_HM_ifNotPresent(clientDO_HM: any, clientObject: any) {
    const [clientRefGuid, clientData] = Object.entries(clientObject)[0];
      if (!clientDO_HM[clientRefGuid]) clientDO_HM[clientRefGuid] = clientData;
  }
  

}

export interface EmitterObject {
    clientDOHM: Map<string, any>;
    claimClientRoles: Map<string, any>;
    claimantHM: Map<string, any>;
    claimPayments:any;
}

export class ClientRoleDO{
    clientRefGuid : any;
    roleCd : any;
    clientDO : any
}
